import React, { Component } from 'react';
import Axios from 'axios';
import {orderStatus} from '../utils'
import { Row } from 'react-bootstrap';
class PrinterControls extends Component {
    state = {}
    clear = () => {
        Axios.post("/api/jobs/print/cleared", { printer: this.props.data.printer._id, job: this.props.data.printer.active_job })
    }
    removeJobFromPrinter = () => {
        Axios.post("/api/jobs/print/remove/job/from/printer", { printer: this.props.data.printer._id, job: this.props.data.printer.active_job })
    }

    restart = () => {
        Axios.post("/api/jobs/restart/by/job", { printer: this.props.data.printer._id, job: this.props.data.printer.active_job })

    }
    cancel = () => {
        Axios.post("/api/jobs/cancel/by/job", { printer: this.props.data.printer._id, job: this.props.data.printer.active_job })

    }
    pause = () => {
        Axios.post("/api/jobs/pause/by/job", { printer: this.props.data.printer._id, job: this.props.data.printer.active_job })
    }
    resume = () => {
        Axios.post("/api/jobs/resume/by/job", { printer: this.props.data.printer._id, job: this.props.data.printer.active_job })
    }
    requeue = () => {
        Axios.post("/api/jobs/requeue/by/job", { printer: this.props.data.printer._id, job: this.props.data.printer.active_job })
    }
    shutDownHeatingElements = () => {
        Axios.post("/api/jobs/turn/off/heating/elements", { printer: this.props.data.printer._id, job: this.props.data.printer.active_job })
    }
    turnOnHeatingElements = () => {
        Axios.post("/api/jobs/turn/on/heating/elements", { printer: this.props.data.printer._id, job: this.props.data.printer.active_job })
    }
    render() {
        let printer = this.props.data
        if (!printer) {
            return (<div></div>)
        }
        return (
<div >
                {printer?.jobActual?.printStatus == 9 &&
                <div style={{ margin: "auto", width: "300px" }}>
                    <button style={{ margin: "10px", width: "300px" }} onClick={this.resume}>Resume Print</button>
                    </div>

                }
                {printer.jobActual && printer?.jobActual?.printStatus == 0 &&
                <div style={{ margin: "auto", width: "300px" }}>

                    <button style={{ margin: "10px", width: "300px" }} onClick={this.pause}>Pause Print</button>
                                        </div>

                }
                {printer.jobActual && (printer.jobActual.printStatus == 0 || printer.jobActual.printStatus == 9) &&
                    <div style={{ margin: "auto", width: "300px" }}>
                        <button style={{ margin: "10px", width: "300px" }} onClick={this.cancel}>Cancel Print</button>
                        <button style={{ margin: "10px", width: "300px" }} onClick={this.shutDownHeatingElements}>Shut down heating elements</button>
                        <button style={{ margin: "10px", width: "300px" }} onClick={this.turnOnHeatingElements}>Turn on heating elements</button>
                    </div>
                }
                {printer.jobActual && (printer.jobActual.printStatus == 2) &&
                    <div style={{ margin: "auto", width: "300px" }}>
                        <button style={{ margin: "10px", width: "300px" }} onClick={this.requeue}>Requeue Print</button>
                        <button style={{ margin: "10px", width: "300px" }} onClick={this.restart}>Restart Print</button>

                    </div>
                }
                {printer.jobActual && (printer.job?.progress?.completion === 100) &&
                <div style={{ margin: "auto", width: "300px" }}>

                    <button style={{ margin: "10px", width: "300px" }} onClick={this.clear}>Printer Cleared / Move to QA</button>
                                        </div>

                }
                                {printer.jobActual && (printer.jobActual?.printStatus == 2) &&
                <div style={{ margin: "auto", width: "300px" }}>

                    <button style={{ margin: "10px", width: "300px" }} onClick={this.removeJobFromPrinter}>Remove Job</button>
                                        </div>

                }
                {printer.job?.progress?.completion !== 100 && printer.jobActual && printer?.jobActual?.printStatus == 0 && !printer?.info?.state?.flags?.resuming && !printer?.info?.state?.flags?.printing && !printer?.info?.state?.flags?.pausing
                    && !printer?.info?.state?.flags?.paused && printer?.info?.state?.flags?.operational && !printer?.info?.state?.flags?.finishing && !printer?.info?.state?.flags?.cancelling &&
                    <div style={{ margin: "auto", width: "300px" }}>
                        Printer Failed To Start Job Or Job Finished and Octopi Reset.
                        <button style={{ margin: "10px", width: "300px" }} onClick={this.clear}>Printer Cleared</button>
                    </div>

                }
            </div>
        );
    }
}

export default PrinterControls;